import { css } from 'wiloke-react-core';

export const container = css`
  debug: BlankPage-Container;
  /* max-width: 1200px; */
  min-height: 800px;
  max-height: 800px;
`;
